import React, { useState, useEffect, useRef } from 'react';
import moment from "moment";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import DefaultData from '../../CompanyData/DefaultData';
const HotelReview = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [pageLoading, setPageLoading] = useState(true);
    const [checkIn, setCheckIn] = useState(new Date());
    const [checkOut, setCheckOut] = useState(new Date());
    const [nights, setNights] = useState(1);
    const [searchQuery, setSearchQuery] = useState({});
    const [hotelBookingRequest, setHotelBookingRequest] = useState({});
    const [saveHotel, setSaveHotel] = useState({});
    const [hotelRoom, setHotelRoom] = useState({});
    const [guestRooms, setGuestRooms] = useState([]);
    const [customerPrice, setCustomerPrice] = useState(0);
    const [markup, setMarkup] = useState(0);
    const [paymentGateway, setPaymentGateway] = useState("RAZORPAY");
    const handleBooking = (e) => {
        e.preventDefault();
        displayRazorpay();
    };
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
        }
    }
    function loadScript(src) {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
            document.body.appendChild(script);
        });
    }
    async function displayRazorpay() {
        const res = await loadScript(
            "https://checkout.razorpay.com/v1/checkout.js"
        );

        if (!res) {
            alert("Razorpay SDK failed to load. Are you online?");
            return;
        }
        // creating a new order
        const result = await apiService.post(config.MAKEPAYMENT + "?Amount=" + Math.round(parseFloat(hotelBookingRequest.totalPrice) + parseFloat(hotelBookingRequest.paymentGatewayAmount)) + "&PayRequest=" + paymentGateway + "&CompanyId=" + DefaultData?.DEFAULTCOMPANYID);
        console.log(result);
        if (result.succeeded) {
            const { amount, id: order_id, currency, razorpayKey, name } = result.data;

            const options = {
                key: razorpayKey, // Enter the Key ID generated from the Dashboard
                amount: amount,
                currency: currency,
                name: name,
                description: "Hotel Booking Fee",
                order_id: order_id,
                handler: async function (response) {
                    const data = {
                        orderCreationId: order_id,
                        razorpayPaymentId: response.razorpay_payment_id,
                        razorpayOrderId: response.razorpay_order_id,
                        razorpaySignature: response.razorpay_signature,
                    };
                    InsertBooking(response.razorpay_payment_id, hotelBookingRequest);
                },
                prefill: {
                    name: DefaultData?.DEFAULTBRANDNAME,
                    email: DefaultData?.DEFAULTCOMPANYEMAIL,
                    contact: DefaultData?.DEFAULTCOMPANYPHONENUMBER,
                },
                notes: {
                    address: DefaultData?.DEFAULTCOMPANYADDRESS,
                },
                theme: {
                    color: DefaultData?.THEMECOLOR1,
                },
            };

            const paymentObject = new window.Razorpay(options);
            paymentObject.open();
        }
        else {
            alert('payment issue')
        }
    }
    const InsertBooking = async (paymentGatewayNo, hotelBookingRequest) => {
        setPageLoading(true)
        hotelBookingRequest.transactionNo = paymentGatewayNo;
        hotelBookingRequest.paymentStatus = "SUCCESS";
        hotelBookingRequest.paymentGatewayNo = paymentGatewayNo;
        hotelBookingRequest.gatewayAmount = parseFloat(hotelBookingRequest.totalPrice) + parseFloat(hotelBookingRequest.paymentGatewayAmount);
        hotelBookingRequest.walletAmount = 0;
        hotelBookingRequest.creditAmount = 0;
        hotelBookingRequest.markup = parseFloat(markup);
        hotelBookingRequest.customerPrice = parseFloat(customerPrice);
        hotelBookingRequest.totalPrice = parseFloat(hotelBookingRequest.totalPrice) + parseFloat(customerPrice) + parseFloat(markup);
        setPageLoading(true)
        var response = await apiService.post(config.BOOKHOTEL, hotelBookingRequest)
        console.log(response);
        if (response.succeeded) {
            var hotelbookingResponse = response.data;
            setPageLoading(false);
            navigate('/my-hotel/booking/' + hotelbookingResponse.hotelBookingId);
        }
        else {
            alert("Error in booking confirmation. Please contact admin")
        }
    };
    const getTransactionFee = (paymentGateways) => {
        if (Array.isArray(paymentGateways)) {
            const payment = paymentGateways.find(
                (setting) => setting.paymentGatewayName === paymentGateway
            );
            return payment ? payment.transactionFee : null;
        }
        else {
            return 0;
        }
    };
    useEffect(() => {
        console.log(state);
        if (state === null) {
            navigate('/search/hotels')
        }
        const hotelBookingRequest = state.responseData;
        console.log(hotelBookingRequest);
        if (hotelBookingRequest === null) {
            navigate('/search/hotels')
        }
        else if (hotelBookingRequest.commonHotelSearchRequest === null) {
            navigate('/search/hotels')
        }
        else {
            setPageLoading(false);
            setHotelBookingRequest(hotelBookingRequest);
            setSearchQuery(hotelBookingRequest.commonHotelSearchRequest)
            setSaveHotel(hotelBookingRequest.commonHotelDetails)
            setHotelRoom(hotelBookingRequest.commonHotelAllRooms)
            setGuestRooms(hotelBookingRequest.hotelGuestInfos)
            setCheckIn(hotelBookingRequest.commonHotelSearchRequest.checkInDate)
            setCheckOut(hotelBookingRequest.commonHotelSearchRequest.checkOutDate)
            const cinDate = new Date(hotelBookingRequest.commonHotelSearchRequest.checkInDate);
            const coutDate = new Date(hotelBookingRequest.commonHotelSearchRequest.checkOutDate);
            const diffTime = Math.abs(coutDate.getTime() - cinDate.getTime());
            const nights = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            setNights(nights);
        }
    }, []);
    return (
        <div className="container-fluid mt-2">
            <div className="row align-items-start">
                <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="row align-items-start">
                        <div className="col-xl-8 col-lg-8 col-md-12">
                            <div className="div-title card d-flex py-3 mt-3">
                                <h5 className="fw-semibold fs-6 p-3">Booking Summary</h5>
                                <ul className="list-group list-group-borderless">
                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                        <span className="fw-medium mb-0">Hotel Name : {saveHotel.hotelName}</span>
                                    </li>
                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                        <span className="fw-medium mb-0">Address : {saveHotel.address}, {saveHotel.cityName},{saveHotel.countryName},{saveHotel.postalCode}</span>
                                    </li>
                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                        <span className="fw-medium mb-0">Check-In : {moment(checkIn).format('DD-MM-YYYY')}</span>
                                    </li>
                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                        <span className="fw-medium mb-0">Check-Out : {moment(checkOut).format('DD-MM-YYYY')}</span>
                                    </li>
                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                        <span className="fw-medium mb-0">Nights : {nights}</span>
                                    </li>
                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                        <span className="fw-medium mb-0">Total Guests : {searchQuery?.totalGuests}</span>
                                    </li>
                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                        <span className="fw-medium mb-0">Total Rooms : {searchQuery?.hotelRooms?.length}</span>
                                    </li>
                                    {hotelRoom?.requestedHotels?.length > 0 && hotelRoom?.requestedHotels.map((rh, index) =>
                                        <li className="list-group-item d-flex justify-content-between">
                                            <span className="fw-medium mb-0">Room {index + 1} : {rh.roomType}</span>
                                        </li>
                                    )}
                                </ul>
                            </div>
                            <div className="div-title card d-flex py-3 mt-3">
                                <h5 className="fw-semibold fs-6 p-3">Guest Details</h5>
                                <div className="table-responsive-md">
                                    <table className="table table-hover table-bordered">
                                        <thead>
                                            <tr>
                                                <td>Room</td>
                                                <td>Title</td>
                                                <td>First Name</td>
                                                <td>Last Name</td>
                                                <td>Pan Card</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {guestRooms.length > 0 && guestRooms.map((room, index) => (
                                                <>
                                                    {room.adultsFields.length > 0 && room.adultsFields.map((ra, adultIndex) => (
                                                        <tr key={`adult-${index}-${adultIndex}`}>
                                                            <td>Room {index + 1}</td>
                                                            <td>{ra.title}</td>
                                                            <td>{ra.firstName}</td>
                                                            <td>{ra.lastName}</td>
                                                            <td>{ra.panCard}</td>
                                                        </tr>
                                                    ))}
                                                    {room.kidsFields.length > 0 && room.kidsFields.map((rk, kidIndex) => (
                                                        <tr key={`kid-${index}-${kidIndex}`}>
                                                            <td>Room {index + 1}</td>
                                                            <td>{rk.title}</td>
                                                            <td>{rk.firstName}</td>
                                                            <td>{rk.lastName}</td>
                                                            <td>{rk.panCard}</td>
                                                        </tr>
                                                    ))}
                                                </>
                                            ))}

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-12">
                            <div className="side-block card rounded-2 p-3">
                                <div className="bott-block d-block mb-3">
                                    <h5 className="fw-semibold fs-6">Payment Summary</h5>
                                    <ul className="list-group list-group-borderless">
                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                            <span className="fw-medium mb-0">Net Price</span>
                                            <span className="fw-semibold">INR {Math.round(hotelRoom.price)}</span>
                                        </li>
                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                            <span className="fw-medium mb-0">Taxes & Fees</span>
                                            <span className="fw-semibold">INR {Math.round(parseFloat(hotelBookingRequest.convenienceFee) + parseFloat(hotelBookingRequest.paymentGatewayAmount))}</span>
                                        </li>
                                        {hotelRoom.tcsAmount > 0 ?
                                            <li className="list-group-item d-flex justify-content-between align-items-center">
                                                <span className="fw-medium mb-0">TCS</span>
                                                <span className="fw-semibold">INR {Math.round(hotelRoom.tcsAmount)}</span>
                                            </li>
                                            : ""}
                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                            <span className="fw-medium text-success mb-0">Total Price</span>
                                            <span className="fw-semibold text-success">INR {Math.round(parseFloat(hotelBookingRequest.totalPrice))}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="bott-block">
                                    {pageLoading === false ?
                                        <>
                                            <button className="btn fw-medium btn-secondary full-width me-2" type="button" onClick={handleBooking}>Proceed To Payment</button>
                                        </>
                                        :
                                        <>
                                            <button className="btn fw-medium btn-secondary full-width me-2" type="button" disabled>Loading...</button>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HotelReview;
